import {combine, merge, sample} from 'effector';

import {RestError, showRestError} from 'core/errors';

import {
    commonData$,
    currentGtin$,
    currentGtinChanged,
    error$,
    fetchDataFx,
    codesGenerated,
    fetchProductsFx,
    Gate,
    productsData$,
} from './index';

commonData$.on(fetchDataFx.done, (_, {result}) => result).reset(Gate.close);
productsData$.on(fetchProductsFx.done, (_, {result}) => result).reset(Gate.close);
error$
    .on(fetchDataFx.fail, (_, {error}: {error: Error}) => error as RestError)
    .reset(fetchDataFx, fetchDataFx.done, Gate.open, Gate.close);
currentGtin$.on(currentGtinChanged, (_, payload) => payload);

sample({
    clock: [Gate.open, codesGenerated],
    source: Gate.state,
    fn: (state) => state.id,
    target: fetchDataFx,
});

sample({
    clock: merge([Gate.open, codesGenerated]),
    source: combine({
        state: Gate.state,
    }),
    fn: ({state}) => ({
        orderId: state.id,
        paging: {
            pageNumber: 0,
            pageSize: 1000,
        },
        filters: [],
        sortings: [],
    }),
    target: fetchProductsFx,
});

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
